import { useState } from "react";
import { TypedUseSelectorHook, useSelector } from "react-redux";
import { useGetAdherent } from "../../../hooks/useGetAdherent";
import useWindowDimensions from "../../../hooks/useWindowDimension";
import { RootState } from "../../../redux/reducers";
import { AdhesionAdherentParticulierResponse } from "../../../services/Api/swagger";
import { isAuthenticated } from "../../../services/Authentification/authentification";
import { useBulletinAdhesion } from "./bulletinAdhesion";
import { useProgrammeContrat } from "./programme";

export const useReduxSelector: TypedUseSelectorHook<RootState> = useSelector;

export const useContrat = () => {
  const { listeAdhesions } = useGetAdherent();

  // ADHESION SELECTIONNEE PAR DEFAUT = PREMIERE ADHESION
  const [selectedAdhesion, setSelectedAdhesion] = useState<
    AdhesionAdherentParticulierResponse | undefined
  >(listeAdhesions && listeAdhesions[0]);
  const { fetchingPdf, setLaunchBulletinNumero } = useBulletinAdhesion();
  const { handleChangeProgramme, tabs } = useProgrammeContrat(selectedAdhesion);
  const { width } = useWindowDimensions();
  const authenticated = isAuthenticated();

  // Ouverture du panneau à gauche
  const [open, setOpen] = useState(true);
  const handleDrawer = () => {
    setOpen(!open);
  };
  // NE PAS AFFICHER LE PANNEAU SI UNE SEULE ADHESION
  const displayLeftDrawer = listeAdhesions && listeAdhesions.length > 1;

  //LANCEMENT DU TELECHARGEMENT DU BULLETIN
  const selectLinks = (id) => {
    if (id === "telechargerContrat") {
      setLaunchBulletinNumero(selectedAdhesion?.numeroAdhesion);
    }
  };

  return {
    listeAdhesions,
    fetchingPdf,
    setLaunchBulletinNumero,
    handleChangeProgramme,
    width,
    authenticated,
    open,
    handleDrawer,
    displayLeftDrawer,
    selectLinks,
    setSelectedAdhesion,
    selectedAdhesion,
    tabs,
  };
};
